import { gsap } from "../core/gsap";

const SELECTOR_SECTION = '[data-hero-banner]';

export function initHeroBanner() {
  document.querySelectorAll<HTMLElement>(SELECTOR_SECTION).forEach((el) => {
    // Skip if already initialized
    if (el.dataset.gsapInit === "true") return;

    // check if the element contains data-parallax attribute in the same element
    const parallax = el.dataset.parallax === "true";
    const heroImages = el.querySelectorAll<HTMLElement>('[data-hero-banner-media]');

    if (parallax) {
      heroImages.forEach((image) => {
        gsap.to(image, {
          y: -200,
          scrollTrigger: {
            trigger: el,
            scrub: true,
            start: "top top",
            end: "bottom top",
          },
          ease: 'none',
          immediateRender: false
        })
      });
    }

    
    el.dataset.gsapInit = "true";
  });
}